import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import Timeband from '../../../records/Timeband';
import MomentPropTypes from "../../../helpers/MomentPropTypes";
import trainTime from '../../../lib/TrainTime';
import t from '../../../lib/I18n';
import TrackingActions from "../../../actions/TrackingActions";
import { widgetSearchElements, JourneyDirections } from "../../../constants/AppConstants";

import TimeSelector from './TimeSelector';
import DateSelector from './DateSelector';
import TodayTomorrowControls from './TodayTomorrowControls';
import ArriveDepart from './ArriveDepart';

function OutboundDateSelector ({ className, timeband, min, max, disabled, onChange, id, disableTodayTomorrow, autoFocusedElt }) {

    const handleChangeFor = (field, trackingEvent) => (value) => {
        if (trackingEvent === widgetSearchElements.timeSelector) {
            TrackingActions.widgetSearchClick({ name: 'outbound-time', value });
        } else if (trackingEvent === widgetSearchElements.arriveDepart) {
            TrackingActions.widgetSearchClick({ name: 'outbound-arrive-depart', value });
        } else if (trackingEvent === widgetSearchElements.dateSelector) {
            TrackingActions.widgetDaySelect({ date: value, type: 'outbound' });
        }
        onChange(timeband.set(field, value));
    };

    const { datetime, arriveDepart } = timeband;

    return (
        <div className={ `${className} timeband-selector` }
            id={ id }>
            <TodayTomorrowControls
                startDate={ trainTime().set({ hour: datetime.hour(), minute: datetime.minute() }) }
                onChange={ handleChangeFor('datetime') }
                disabled={ disabled || disableTodayTomorrow }
                srOnly={ t('ariaLabel.setFieldDescription', { field: t('ariaLabel.outboundDateField') }) }
                autoFocusedElt={ autoFocusedElt } />

            <DateSelector datetime={ datetime }
                    min={ min }
                    max={ max }
                    onChange={ handleChangeFor('datetime', widgetSearchElements.dateSelector) }
                    disabled={ disabled }
                    srOnly={ t('ariaLabel.fieldDescription', { field: t('ariaLabel.outboundDateField') }) }/>

            <ArriveDepart arriveDepart={ arriveDepart }
                    onChange={ handleChangeFor('arriveDepart', widgetSearchElements.arriveDepart) }
                    direction={ JourneyDirections.OUTWARD }
                    disabled={ disabled } />

            <TimeSelector datetime={ datetime }
                    min={ min }
                    max={ max }
                    onChange={ handleChangeFor('datetime', widgetSearchElements.timeSelector) }
                    disabled={ disabled } />
        </div>
    );

}

OutboundDateSelector.propTypes = {
    className: PropTypes.string,
    timeband: PropTypes.instanceOf(Timeband),
    onChange: PropTypes.func,
    min: MomentPropTypes.isMoment,
    max: MomentPropTypes.isMoment,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    disableTodayTomorrow: PropTypes.bool,
    autoFocusedElt: PropTypes.func
};

OutboundDateSelector.defaultProps = {
    timeband: new Timeband(),
    className: '',
    onChange: _.noop,
    min: null,
    max: null,
    disabled: false,
    id: _.uniqueId('outbound-timeband-selector'),
    disableTodayTomorrow: false,
    autoFocusedElt: _.noop
};


export default OutboundDateSelector;



// WEBPACK FOOTER //
// ./src/components/search/dates/OutboundDateSelector.js